import { render, staticRenderFns } from "./RegulationsFamilyGrid.vue?vue&type=template&id=5da24489&"
import script from "./RegulationsFamilyGrid.vue?vue&type=script&lang=js&"
export * from "./RegulationsFamilyGrid.vue?vue&type=script&lang=js&"
import style0 from "./RegulationsFamilyGrid.vue?vue&type=style&index=0&id=5da24489&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports